<table mat-table [dataSource]="gridDataList" multiTemplateDataRows class="matTables productTable">
  <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
    <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
    <div *ngIf="column=='flashmsg'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">&nbsp;</th></div>
    <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="package">&nbsp;</th></div>
    <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Ordered Quantity</th></div>
    <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="quantityBlock  text-center">Order UOM</th></div>
    <div *ngIf="column=='totalGallons'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Total</th></div>

                                        <td mat-cell *matCellDef="let element">
                                          <div *ngIf="column=='product'">
                                            <div class="order-info defaultCursor margin-l0">
                                              <div class="d-block d-sm-block d-md-none">Product</div>
                                              <span style="width: 90%;">
                                                <p><span *ngIf="element.itemVendorName" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }" [attr.data-testid]="'lbl-vendor-name_'+element.itemNumber+'_'+itemSplitIndex">{{element.itemVendorName}}</span> </p>
                                                <p class="grower-name" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }" [attr.data-testid]="'lbl-product-name_'+element.itemNumber+'_'+itemSplitIndex" [attr.data-supplier]="'supplier-number-'+element.supplierNumber">{{element.productName}}</p>
                                                <p><span *ngIf="element.yourPrice && plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
                                                <p><span *ngIf="element.paymentTerms && plAccess==true" class="paymentTerm">{{element.paymentTerms}}</span></p>
                                              </span>
                                              <span  *ngIf="element.isBIO" style=" vertical-align: top; margin-top: 10px;width: 10%;">
                                                <img src="../../../../../assets/icon/svg/WU_Bioverified_Green.png" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" />
                                              </span>
                                              <!--<p class="grower-name">{{element.itemNumber}}</p>-->
                                            </div>
                                          </div>
                                          <div *ngIf="column=='flashmsg'">
                                            <div [ngClass]="{'order-info-outer-flash-message' :((element.itemFlashMsgDesc!='') && (element.itemFlashMsgDesc!=null))}" *ngIf="element.itemFlashMsgDesc!=''">
                                              {{element.itemFlashMsgDesc}}
                                            </div>
                                          </div>
                                          <div *ngIf="column=='detail'" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED','showHideDetails text-center  m-center': element.lineStatus !=='CANCELLED' }">
                                            <!-- <div class="d-block d-sm-block d-md-none">&nbsp;</div> -->
                                            <ng-container *ngIf="element.lineStatus !=='CANCELLED';else elseBlock">
                                              <a (click)="showProductDetails(element);" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }" [attr.data-testid]="'btn-show-product-details_'+element.itemNumber+'_'+itemSplitIndex">{{element.isDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
                                            </ng-container>
                                            <ng-template #elseBlock>
                                              <ng-container class="text-center productDetailsFont m-center">View Product Details</ng-container>
                                            </ng-template>
                                          </div>
                                          <div *ngIf="column=='quantity'" class="text-center largeTableTxt mobile-col-set">
                                            <div class="d-block d-sm-block d-md-none">Order Quantity</div>
                                            <div class="m-center">
                                              <ng-container *ngIf="element.lineStatus !='CANCELLED'">
                                                <div class="m-center" [attr.data-testid]="'lbl-order-quantity_'+element.itemNumber+'_'+itemSplitIndex">
                                                  {{element.originalOrderQuantity}}
                                                </div>
                                              </ng-container>
                                              <ng-container *ngIf="element.lineStatus=='CANCELLED'" class="disabledrow">Cancelled</ng-container>
                                            </div>
                                          </div>
                                          <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt mobile-col-set" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">
                                            <div class="d-block d-sm-block d-md-none">Order UOM</div> <div class="m-center" [attr.data-testid]="'lbl-order-uom_'+element.itemNumber+'_'+itemSplitIndex">{{element.uom}}</div>
                                          </div>
                                          <div *ngIf="column=='totalGallons'" class="text-center largeTableTxt mobile-col-set" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">
                                            <div class="d-block d-sm-block d-md-none">Total</div> <div class="m-center" [attr.data-testid]="'lbl-total-gallons_'+element.itemNumber+'_'+itemSplitIndex">{{element.totalGallons}}</div>
                                          </div>
                                        </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
        <div class="cpp-prod-info mobile-nested-table">
          <table style="width:100%">
            <tbody>
              <tr class="xs-hide">
                <th width="10%" class="text-left">Item #</th>
                <th width="12%">GTIN</th>
                <th width="12%">Product Line</th>
                <th width="18%">Active Ingredients</th>
                <!--<th width="10%">National Price</th>-->
                <th width="11%">Pallet Quantity</th>
                <th width="11%">Restricted Use</th>
                <th width="13%">Non-Returnable</th>
                <th width="13%">Package Size</th>
              </tr>
              <tr>
                <!-- Responsive headings for small screens -->
                <th width="10%" class="d-block d-sm-block d-md-none">Item #</th>
                <td width="10%" class="text-left">
                  <p [attr.data-testid]="'lbl-item-number-'+itemSplitId+'_'+(element.rowIndex+1)">{{element.itemNumber}}</p>
                </td>

                <th width="12%" class="d-block d-sm-block d-md-none">GTIN</th>
                <td width="12%"><p>{{element.gtin}}</p></td>

                <th width="12%" class="d-block d-sm-block d-md-none">Product Line</th>
                <td width="12%"><p>{{element.productLine}}</p></td>

                <th width="18%" class="d-block d-sm-block d-md-none">Active Ingredients</th>
                <td width="18%"><p>{{element.activeIngredient}}</p></td>

                <!--<th width="10%" class="d-block d-sm-block d-md-none">National Price</th>
        <td width="10%"><p>{{element.price | number:'1.4-4'}}</p></td>-->

                <th width="11%" class="d-block d-sm-block d-md-none">Pallet Quantity</th>
                <td width="11%"><p>{{element.palletQuantity | number:'1.4-4'}}</p></td>

                <th width="11%" class="d-block d-sm-block d-md-none">Restricted Use</th>
                <td width="11%"><p>{{element.restrictedUse}}</p></td>

                <th width="13%" class="d-block d-sm-block d-md-none">Non-Returnable</th>
                <td width="13%">
                  <div [ngClass]="{'oval-shape returnable': (element.returnable === 'X')}">
                    <p>{{element.returnable}}</p>
                  </div>
                </td>

                <th width="13%" class="d-block d-sm-block d-md-none">Package Size</th>
                <td width="13%"><p>{{element.packageSize}}</p></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="showWaring">
    <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" style=" background: #FDCF35;" [style.display]="(element.isRepackItem=='Y' && element.repackAgreement=='N')|| (element.isRepackItem=='Y' && element.repackAgreement==null)|| (element.isRepackItem=='Y' && element.repackAgreement=='') ? '' : 'none'">
      <span class="summary-status-bar">
        1. A Repack Agreement is expired or missing for {{element.itemDescription}} ,{{element.itemNumber}}. This item will not ship until a repack agreement has been signed.
      </span>
      <br />
      <span class="summary-status-bar">
        This item will notPlease reach out to winfieldcustomerservice&#64;landolakes.com or 855-494-6343 to get an agreement sent.
      </span>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;" [ngClass]="{ 'Cancelled': element.lineStatus =='CANCELLED' }"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  <tr mat-row *matRowDef="let row; columns: ['showWaring']" class="example-detail-row"></tr>
</table>
<div *ngIf="gridDataList == undefined || gridDataList?.length == 0" class="noDataMsg">
  <p>No Record Found.</p>
</div>
